module.exports = __webpack_public_path__ + "ViasportNO-c0336a16206c98efe4644c44cd18d4c7.png";


//////////////////
// WEBPACK FOOTER
// ./assets/logos/ViasportNO.png
// module id = 1153
// module chunks = 0 1